import Badge from "../components/Badge";
import { uomApi, pannaApi, matchingApi, colorApi } from "../api/apiIndex";
import T from "../theme/colors";

// ─── UOM ──────────────────────────────────────────────────────────────────
// Phase 36da.99.ch — `module` field added on every master config so
// SimpleMaster can gate Add / Edit / Delete buttons against the same
// granular per-permission map the backend uses.  Previously
// SimpleMaster relied on canManage() (role-only), which meant
// LOCATION_MANAGER/STAFF saw "view only" even after an admin had
// ticked CREATE/EDIT for them, and COMPANY_ADMIN saw the Add button
// but the backend rejected the request unless an explicit grant
// existed.  These module strings MUST match the backend PageModule
// enum values exactly.
export const UOM_CONFIG = {
  title:      "UOM Master",
  subtitle:   "Units of measurement — Meter, Kg, Pcs, Yard etc.",
  entityName: "UOM",
  module:     "UOM",
  api:        uomApi,
  cols: [
    { key: "uomName",  label: "UOM Name"   },
    { key: "uomShort", label: "Short Code", dim: true },
  ],
  formFields: [
    { key: "uomName",     label: "UOM Name",    placeholder: "e.g. Meter",    required: true, full: true },
    { key: "uomShort",    label: "Short Code",  placeholder: "e.g. M",        required: true, full: true },
    { key: "description", label: "Description", placeholder: "Optional",                      full: true },
  ],
};

// ─── Panna ────────────────────────────────────────────────────────────────
export const PANNA_CONFIG = {
  title:      "Panna Master",
  subtitle:   'Cloth width sizes — 36", 44", 54", 58"',
  entityName: "Panna",
  module:     "PANNA",
  api:        pannaApi,
  cols: [
    { key: "pannaSize",  label: 'Width (in")',
      render: v => <span style={{ fontWeight: 600, color: T.text0 }}>{v}"</span> },
    { key: "pannaLabel", label: "Label", dim: true },
  ],
  formFields: [
    { key: "pannaSize",  label: 'Panna Width (inches)', placeholder: "e.g. 54", required: true, type: "number", full: true },
    { key: "pannaLabel", label: "Label",                placeholder: "e.g. 54 inch",                            full: true },
  ],
};

// ─── Matching ─────────────────────────────────────────────────────────────
export const MATCHING_CONFIG = {
  title:      "Matching Master",
  subtitle:   "Cloth matching types — Main, Collar, Cups, Pocket, etc.",
  entityName: "Matching",
  module:     "MATCHING",
  api:        matchingApi,
  cols: [
    { key: "matchingName", label: "Matching Name" },
    { key: "isDefault",    label: "Default",
      render: v => v
        ? <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 4, background: T.successBg, color: T.success, border: `1px solid ${T.successBdr}` }}>Main</span>
        : <span style={{ fontSize: 11, color: T.text2 }}>—</span>
    },
  ],
  formFields: [
    { key: "matchingName", label: "Matching Name",  placeholder: "e.g. Collar", required: true, full: true },
    {
      key: "isDefault", label: "Set as Default (Main Matching)", type: "select",
      defaultValue: "false", full: true,
      options: [
        { value: "false", label: "No — Regular matching"   },
        { value: "true",  label: "Yes — Main matching type" },
      ],
    },
  ],
};

// ─── Color ────────────────────────────────────────────────────────────────
export const COLOR_CONFIG = {
  title:      "Color Master",
  subtitle:   "Define fabric and lump color palette",
  entityName: "Color",
  module:     "COLOR",
  api:        colorApi,
  cols: [
    { key: "colorName", label: "Color Name" },
  ],
  formFields: [
    { key: "colorName",   label: "Color Name",  placeholder: "e.g. Navy Blue", required: true, full: true },
    { key: "description", label: "Description", placeholder: "Optional",                        full: true },
  ],
};